import { Component } from '@angular/core';
import { FeedbackService } from '../../services/feedback.service';
import { AlertController } from '@ionic/angular';

@Component({
    selector: 'app-feedback-modal',
    templateUrl: './feedback-modal.component.html',
    styleUrls: ['./feedback-modal.component.scss'],
    standalone: false
})
export class FeedbackModalComponent {
  feedback: string = '';
  loading = false;

  constructor(
    protected feedbackService: FeedbackService,
    private alertController: AlertController,
  ) {}

  async sendFeedback() {
    this.loading = true;
    await this.feedbackService.sendTextFeedback(this.feedback);
    this.feedback = '';
    this.loading = false;

    this.feedbackService.showFeedbackModal.next(false);

    const alert = await this.alertController.create({
      header: 'Bedankt',
      message: 'Uw feedback is succesvol verstuurd.',
      buttons: ['OK'],
    });
    
    await alert.present();
  }
}
